import { useTenant } from '../../../hooks/useTenant';

/**
 * Login Brand Panel Component
 *
 * Features:
 * - Tenant logo and branding
 * - Product name and tagline
 * - Gradient background with subtle animation
 * - Hidden on mobile devices
 */
export function LoginBrandPanel() {
  const { tenant } = useTenant();

  return (
    <div className="login-brand-panel">
      {/* Animated gradient background */}
      <div className="login-brand-gradient" />

      {/* Content */}
      <div className="login-brand-content">
        {/* Logo */}
        {tenant?.logo && (
          <div className="login-brand-logo">
            <img src={tenant.logo} alt={tenant.displayName || tenant.name} />
          </div>
        )}

        {/* Product Name */}
        <h1 className="login-brand-title">{tenant?.displayName || tenant?.name || 'Platform'}</h1>

        {/* Tagline */}
        <p className="login-brand-tagline">
          Modern, secure, and scalable multi-tenant platform for your business needs.
        </p>

        {/* Feature highlights */}
        <div className="login-brand-features">
          <div className="login-brand-feature">
            <div className="login-brand-feature-icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M12 2L2 7l10 5 10-5-10-5z" />
                <path d="M2 17l10 5 10-5" />
                <path d="M2 12l10 5 10-5" />
              </svg>
            </div>
            <span>Modular Architecture</span>
          </div>

          <div className="login-brand-feature">
            <div className="login-brand-feature-icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
              </svg>
            </div>
            <span>Enterprise Security</span>
          </div>

          <div className="login-brand-feature">
            <div className="login-brand-feature-icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
              </svg>
            </div>
            <span>Lightning Fast</span>
          </div>
        </div>
      </div>

      {/* Decorative elements */}
      <div className="login-brand-decoration">
        <div className="login-brand-circle login-brand-circle-1" />
        <div className="login-brand-circle login-brand-circle-2" />
        <div className="login-brand-circle login-brand-circle-3" />
      </div>
    </div>
  );
}
